import { useEffect, useState } from "react";
import { MdOutlinePhoneAndroid } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../../redux/slice/auth.slice";
import { USER_VERIFY } from "../../../../redux/types/auth.types";
import Button from "../../../ui/Button";
import InputTextField from "../../../ui/InputTextField";
import { useNavigate } from "react-router-dom";

const Authenticate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const currentUser = useSelector(authActions.selectors.getCurrentUser);
  const submitHandler = (e) => {
    e.preventDefault()
    dispatch({ type: USER_VERIFY, payload: { email: currentUser?.email, verification_code : code }})
  }
  const auth = useSelector(authActions.selectors.getLoggedInStatus);
  useEffect(() => {
    if (auth) {
      navigate('/')
    }
  }, [auth, navigate])
  const [code, setCode] = useState('');
  const handleCode = (name , value) =>{
    if (value.toString().length > 5){
      return
    }
    setCode(value)
  }

  return (
    <form className="flex flex-wrap flex-col justify-center px-1 h-svh md:px-32" onSubmit={submitHandler}>
      <div className="text-4xl font-bold">
        Authenticate your
        <br />
        Account
      </div>
      {/* number or email  */}
      <div className="mt-4 text-lg text-lightGrey">
        Please confirm your account by entering authorization code <br />
        sent to {currentUser?.email}
      </div>
      <div className="mt-3">
        <InputTextField
          label="Verification Code*"
          type="text"
          value={code}
          icon={<MdOutlinePhoneAndroid size={24} />}
          placeholder="Enter verification code"
          onChange={handleCode}
          name="code"
        />
        {/* <div className="text-red text-sm mt-2">Invalid code, Try again</div> */}
      </div>
      <div className="mt-7">
        <Button title="Verify" />
      </div>
      <div className="mt-3 flex text-xs font-semibold gap-1">
        <div className="text-lightGrey">
          It may take a minute to receive your code.
          <br />
          Haven’t received it?{" "}
          <span className="text-secondary">Resend new code </span>
        </div>
      </div>
    </form>
  );
};

export default Authenticate;
